<template>
  <div class="guaranteed-bad-record-list">
    <Collapse simple v-model="tableToolsPanel" class="table-tools-panel" accordion>
      <Panel name="filter" hide-arrow>
        <div class="table-tools-panel-title"><Icon class="table-tools-panel-title-icon" type="ios-funnel" />筛选</div>
        <div class="pull-right">
          <Tooltip content="刷新结果">
            <Button @click.stop="refresh" type="text" size="large" icon="ios-refresh"></Button>
          </Tooltip>
          <Divider type="vertical" />
          <Tooltip :content="tableToolsPanel.indexOf('filter')>-1?'隐藏筛选条件':'展开筛选条件'">
            <Button type="text" size="large" :icon="tableToolsPanel.indexOf('filter')>-1? 'ios-arrow-up':'ios-arrow-down'"></Button>
          </Tooltip>
        </div>
        <div slot="content">
          <div class="padding-top-20"></div>
          <Form ref="filterForm" :model="filterModel" inline :show-message="false" :label-width="140">
            <Row :gutter="8">
              <i-col span="8">
                <FormItem label="投保人名称" prop="guaranteedName">
                  <Input v-model="filterModel.guaranteedName" />
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="统一社会信用代码" prop="guaranteedBusinessLicense">
                  <Input v-model="filterModel.guaranteedBusinessLicense" />
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="代偿项目名称" prop="projectName">
                  <Input v-model="filterModel.projectName" />
                </FormItem>
              </i-col>
            </Row>
            <Row :gutter="8">
              <i-col span="8">
                <FormItem label="项目经理姓名" prop="prjManagerName">
                  <Input v-model="filterModel.prjManagerName" />
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="担保品种" prop="guaType">
                  <Select v-model="filterModel.guaType" filterable>
                    <Option :value="null">不限</Option>
                    <Option v-for="(tp,idx) in guaTypes" :key="idx" :value="parseInt(tp.id)">{{tp.fullName}}</Option>
                  </Select>
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="项目所在地" prop="prjCityId">
                  <Cascader v-model="filterModel.cities" :data="cities" :load-data="loadCityData" @on-change="citySelected" placeholder="选择"></Cascader>
                </FormItem>
              </i-col>
            </Row>
            <Row :gutter="8">
              <i-col span="8">
                <FormItem label="代偿日期" prop="compensationDate">
                  <Date-picker type="daterange" :value="filterModel.compensationDateRange" @on-change="changeCompensationDateRange"></Date-picker>
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="约定还款日期" prop="agreedDate">
                  <Date-picker type="daterange" :value="filterModel.agreedDateRange" @on-change="changeAgreedDateRange"></Date-picker>
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="是否还款完毕" prop="type">
                  <RadioGroup v-model="filterModel.isPaidOff" type="button">
                    <Radio :label="null">不限</Radio>
                    <Radio :label="1">是</Radio>
                    <Radio :label="0">否</Radio>
                  </RadioGroup>
                </FormItem>
              </i-col>
            </Row>
            <Row :gutter="8">
              <i-col span="16">
                <FormItem style="width: 100%; text-align:right">
                  <Button type="primary" size="large" style="width:144px;" @click="refresh">查询</Button>
                  <Divider type="vertical" />
                  <Button type="error" ghost size="large" @click="$refs['filterForm'].resetFields()">重置</Button>
                </FormItem>
              </i-col>
            </Row>
          </Form>
        </div>
      </Panel>
    </Collapse>
    <div class="padding-top-10"></div>
    <div class="text-right">
      <Button type="primary" to="/guaranteed-bad-record/new" icon="md-add">新增企业信用记录</Button>
    </div>
    <div class="padding-top-10"></div>
    <Table border ref="dataTable"
      size="small"
      stripe
      :columns="columns"
      @on-sort-change="tableSortChange"
      :data="data">
    </Table>
    <Page class="pager"
      :total="totalCount"
      :current="currentPageIndex"
      @on-change="changePageIndex"
      @on-page-size-change="changePageSize"
      size="small"
      show-elevator
      show-total
      show-sizer />
  </div>
</template>

<script>
export default {
  name: 'guaranteed-bad-record-list',
  props: {
  },
  data () {
    return {
      tableToolsPanel: '',
      guaTypes: [],
      cities: [],
      columns: [
        {
          title: '投保人名称',
          key: 'guaranteedName',
          align: 'center',
          width: 220,
          resizable: true,
          sortMethod: (a, b, type) => {
            if (type === 'asc') {
              return a.localeCompare(b, 'zh-CN')
            } else {
              return b.localeCompare(a, 'zh-CN')
            }
          }
        },
        {
          title: '统一社会信用代码',
          align: 'center',
          key: 'guaranteedBusinessLicense',
          width: 180,
          sortMethod: (a, b, type) => {
            if (type === 'asc') {
              return a.localeCompare(b, 'zh-CN')
            } else {
              return b.localeCompare(a, 'zh-CN')
            }
          }
        },
        {
          title: '代偿项目名称',
          align: 'center',
          key: 'projectName',
          resizable: true,
          width: 280,
          sortMethod: (a, b, type) => {
            if (type === 'asc') {
              return a.localeCompare(b, 'zh-CN')
            } else {
              return b.localeCompare(a, 'zh-CN')
            }
          }
        },
        {
          title: '项目经理',
          align: 'center',
          children: [
            {
              title: '姓名',
              align: 'center',
              key: 'prjManagerName',
              width: 140,
            },
            {
              title: '注册建造师编号',
              align: 'center',
              key: 'prjManagerConstructorNo',
              width: 140,
            }
          ]
        },
        {
          title: '项目所在地',
          align: 'center',
          key: 'prjCity',
          width: 120,
        },
        {
          title: '担保品种',
          align: 'center',
          key: 'guaTypeName',
          width: 120,
        },
        {
          title: '代偿时间',
          align: 'center',
          key: 'compensationDate',
          width: 140,
          sortable: 'custom',
          render: (h, params) => {
            return h('span', null, this.getMoment(params.row.compensationDate).format('YYYY-MM-DD'))
          }
        },
        {
          title: '约定还款时间',
          align: 'center',
          key: 'agreedPayDate',
          width: 140,
          sortable: 'custom',
          render: (h, params) => {
            return h('span', null, this.getMoment(params.row.agreedPayDate).format('YYYY-MM-DD'))
          }
        },
        {
          title: '在双方约定期限内是否还清',
          align: 'center',
          key: 'isPaidOff',
          width: 100,
          sortable: 'custom',
          render: (h, params) => {
            return h('span', null, params.row.isPaidOff ? '是' : '否')
          }
        },
        {
          title: '信息上报时间',
          align: 'center',
          key: 'createTime',
          width: 140,
          sortable: 'custom',
          render: (h, params) => {
            return h('span', null, this.getMoment(params.row.createTime).format('YYYY-MM-DD'))
          }
        },
        {
          title: '操作',
          width: 160,
          fixed: 'right',
          render: (h, params) => {
            if (this.checkRolePermitted(['监管人','总监管人'])) {
              return h('span', null, [
                h('Tooltip', {
                  props: {
                    content: '修改',
                    transfer: true
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'warning',
                      ghost: true,
                      shape: 'circle',
                      icon: 'md-create'
                    },
                    on: {
                      click: () => {
                        // let userId = params.row.id
                        this.$router.push({name: 'guaranteed-bad-record-edit', params: {id: params.row.id}})
                      }
                    }
                  }, null),
                ]),
                h('span', null, ' '),
                h('Tooltip', {
                  props: {
                    content: '删除',
                    transfer: true
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      ghost: true,
                      shape: 'circle',
                      icon: 'ios-trash-outline'
                    },
                    on: {
                      click: () => {
                        let companyId = params.row.id
                        this.delete(companyId)
                      }
                    }
                  }, null)
                ])
              ])
            } else {
              return h('span', null, '')
            }
          }
        }
      ],
      data: [],
      pageSize: 10,
      totalCount: 0,
      currentPageIndex: 1,
      filterModel: {
        guaranteedName: null,
        guaranteedBusinessLicense: null,
        companyId: null,
        projectId: null,
        projectName: null,
        prjManagerName: null,
        prjManagerConstructorNo: null,
        prjCityId: null,
        guaranteeId: null,
        guaType: null,
        isPaidOff: null,
        compensationDateRange: null,
        compensationDateStart: null,
        compensationDateEnd: null,
        agreedPayDateRange: null,
        agreedPayDateStart: null,
        agreedPayDateEnd: null,
        cities: []
      }
    }
  },
  watch: {
    currentPageIndex: function (newVal) {
      if (newVal) {
        this.initData()
      }
    },
    pageSize: function (newVal) {
      if (newVal) {
        this.initData()
      }
    },
  },
  mounted () {
    this.initData()
    this.initCitySelect()
    this.initGuaTypes()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    checkRolePermitted (roles) {
      if (this.$store.getters.userInfo.type === 127) {
        return true
      }
      let userRole = this.$common.userType[this.$store.getters.userInfo.type.toString()]
      if (roles instanceof Array) {
        return roles.indexOf(userRole) > -1
      }
      return roles == userRole
    },
    async initGuaTypes () {
      return new Promise((resolve, reject) => {
        this.$Spin.show()
        this.$Api.Guarantee.getGuaranteeVarieties().then(res => {
          let result
          if (window.localStorage.getItem('view-mode') === 'migrantworker-only') {
            result = res.filter((tp) => {
              return tp.fullName === '建筑务工人员工资支付保证金担保'
            })
            this.filterModel.guaType = result[0].id
          } else {
            result = res
          }
          this.guaTypes = result
          this.$Spin.hide()
          resolve(result)
        }).catch(err => {
          this.$Message.error(err.message)
          this.$Spin.hide()
          reject(err)
        })
      })
    },
    initCitySelect () {
      this.$Api.City.listCities({
        tier: 1,
        isVisible: null
      }, 1, 1000).then((cities) => {
        let data = cities.data.map((c) => {
          return {
            id: c.tid,
            value: c.tid,
            label: c.name,
            tier: c.tier,
            parent: c.parent,
            loading: false,
            children: []
          }
        })
        this.cities = data
      }).catch(err => {
        this.$Message.error('获取城市列表失败!' + err.message)
      })
    },
    loadCityData (item, callback) {
      item.loading = true
      let parentId = item.value
      let tier = item.tier || 0
      let curNode = null
      if (tier === 1) {
        curNode = this.cities.filter((c) => {
          return c.id === item.id
        })[0]
      } else {
        let parentNode = this.cities.filter((c) => {
          return c.id === item.parent
        })
        curNode = parentNode[0]
      }
      console.log(curNode)
      this.$Api.City.listCities({
        tier: tier + 1,
        parentId: parentId,
        isVisible: null
      }, 1, 1000).then((cities) => {
        let data = []
        cities.data.forEach((c) => {
          if (tier === 1) {
            // 地市
            data.push({
              id: c.tid,
              value: c.tid,
              label: c.name,
              tier: c.tier,
              parent: c.parent,
              loading: false,
              children: []
            })
          } else {
            data.push({
              value: c.tid,
              label: c.name,
              tier: c.tier,
              parent: c.parent
            })
          }
        })
        let retData = []
        if (tier > 1) {
          retData.push({
            value: parentId,
            label: '本级'
          })
        } else if (tier === 1) {
          retData.push({
            value: parentId,
            label: '本级'
          })
        }
        data.forEach((d) => {
          retData.push(d)
        })
        if (tier === 0) {
          curNode = retData
        } else {
          item.children = retData
        }
        item.loading = false
        if (callback) {
          callback()
        }
      }).catch(err => {
        this.$Message.error('获取城市列表失败!' + err.message)
        item.loading = false
        if (callback) {
          callback()
        }
      })
    },
    citySelected (val) {
      if (val instanceof Array) {
        this.filterModel.prjCityId = val[val.length - 1]
      } else {
        this.filterModel.prjCityId = val
      }
    },
    changeCompensationDateRange (dates) {
      if (dates instanceof Array) {
        this.filterModel.compensationDateStart = require('moment')(dates[0]).format('YYYY-MM-DDT00:00:00')
        this.filterModel.compensationDateEnd = require('moment')(dates[1]).format('YYYY-MM-DDT23:59:59')
      }
    },
    changeAgreedPayDateRange (dates) {
      if (dates instanceof Array) {
        this.filterModel.agreedPayDateStart = require('moment')(dates[0]).format('YYYY-MM-DDT00:00:00')
        this.filterModel.agreedPayDateEnd = require('moment')(dates[1]).format('YYYY-MM-DDT23:59:59')
      }
    },
    getMoment (dt) {
      return this.$moment(dt)
    },
    refresh () {
      // console.log('123')
      this.currentPageIndex = 1
      this.initData()
    },
    changePageSize (e) {
      this.pageSize = e
    },
    changePageIndex (e) {
      this.currentPageIndex = e
    },
    tableSortChange (e) {
      if (e.key) {
        this.filterModel.sortBy = e.column.sortKey || e.key
        this.filterModel.ascending = e.order === 'normal' ? null : e.order == 'asc' ? true : false
        this.initData()
      }
    },
    async initData () {
      this.$Spin.show()
      let res = await this.$Api.Guarantee.listGuaranteedBadRecord(this.filterModel, this.currentPageIndex, this.pageSize).catch(err => {
        this.$Message.error(err.message)
        this.$Spin.hide()
      })
      this.totalCount = res.totalCount
      this.currentPageIndex = res.currentPage
      this.pageSize = res.pageSize
      this.data = res.data
      this.$Spin.hide()
    },
    async delete (id) {
      this.$Modal.confirm({
        title: '确认操作',
        content: '<p>确认删除该记录么？</p>',
        onOk: async () => {
          // this.$Spin.show()
          await this.$Api.Guarantee.deleteGuaranteedBadRecord(id).catch(err => {
            this.$Notice.error({
              title: '操作失败!',
              desc: err.message
            })
            // this.$Spin.hide()
            return null
          })
          this.$Message.success('操作成功!')
          this.data.splice(this.data.findIndex(o => {return o.Id === id}), 1)
          this.totalCount -= 1
        },
        onCancel: () => {
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.guaranteed-bad-record-list {
}
.table-tools-panel {
  .table-tools-panel-title {
    font-weight: bold;
    display: inline-block;
  }
  .table-tools-panel-title-icon {
    margin-right: 20px;
  }
  .table-tools-panel-title-addon {
    display: inline-block;
    margin-left: 20px;
  }
}
.pager {
  margin: 20px 0;
}
</style>
